import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getUserAdvertList, getUserAdvertStatusInfoes } from "./Services";




export const useGetUserAdverts = (filter:any) => {
  return useQuery(
    [endpoints.getUserAdvertList,filter],
    () => getUserAdvertList(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export const useGetUserAdvertStatus = () => {
  return useQuery(
    [endpoints.getUserAdvertStatusInfo],
    () => getUserAdvertStatusInfoes(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};


